<template>
  <v-card width="400">
    <v-card-title>
      <DialogTitle :dialogName="$options.name">
        {{ isEditMode ? 'Edit' : 'New' }} Custom View Column
      </DialogTitle>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="formData.ColumnName"
        :items="columnNameList"
        item-text="Text"
        item-value="Value"
        label="Column"
        :error-messages="errorMessages(vuelidate.formData.ColumnName)"
        @blur="vuelidate.formData.ColumnName.$touch()"
        dense
      />
      <v-text-field
        v-model="formData.SortOrder"
        label="SortOrder"
        type="number"
        dense
      />
    </v-card-text>
    <v-card-actions
      ><v-btn color="success" class="ml-1" @click="saveClick">{{
        isEditMode ? 'Update' : 'Save'
      }}</v-btn>
      <v-btn color="error" class="ml-3" @click="cancelClick">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, watch } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: 'CustomViewColumnEditor',
  props: {
    info: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    columnNameList: {
      type: Array,
      required: true
    },
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const isEditMode = ref(false)
    const formData = ref()

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      isEditMode.value = props.index >= 0
      formData.value = { ...props.info }
      vuelidate.value.$reset()
    }

    const saveClick = async () => {
      if (!validate()) {
        context.emit('update', { item: formData.value, index: props.index })
      }
    }

    const cancelClick = () => {
      context.emit('close')
    }

    const rules = {
      formData: {
        ColumnName: { required },
        SortOrder: { required }
      }
    }

    const vuelidate = useVuelidate(rules, { formData })

    const errorMessages = item => {
      return vuelidate.value.$invalid ? item.$errors.map(e => e.$message) : []
    }

    const validate = () => {
      vuelidate.value.$touch()
      return vuelidate.value.$invalid
    }

    initDialog()
    return {
      isEditMode,
      formData,
      errorMessages,
      saveClick,
      cancelClick,
      vuelidate
    }
  }
}
</script>

<style lang="scss" scoped></style>
